import { render, staticRenderFns } from "./jingxiao.vue?vue&type=template&id=a3c5c8c6&scoped=true&"
import script from "./jingxiao.vue?vue&type=script&lang=js&"
export * from "./jingxiao.vue?vue&type=script&lang=js&"
import style0 from "./jingxiao.vue?vue&type=style&index=0&id=a3c5c8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c5c8c6",
  null
  
)

export default component.exports